import React, { useState, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import TextInput from "components/Input/TextInput.js";

import CustomSelect from "components/Input/CustomSelect.js";
import UserService from "services/UserService";

import { ceenotification as ceenotificationtext } from "variables/cee";
import { ceenotificationsRecipienttypeData } from "variables/lists/cee";

import { makeStyles } from "@mui/styles";
import { postNotification } from "services/ConfigServices";

import CEECampaignsContext from "context/CEECampaignsContext";
import { NotificationManager } from 'react-notifications';

import styled from "styled-components";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',

  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  textInput: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputImage: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "12px",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

export default function Notifications(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];

  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = ceeCampaignContext;

  const [recipienttype, setRecipienttype] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const handleRecipienttypeChange = (event) => { setRecipienttype(event.target.value); };
  const handleTitleChange = (event) => { setTitle(event.target.value); };
  const handleMessageChange = (event) => { setMessage(event.target.value); };


  const sendNotification = () => {
    axios
      .post(
        postNotification(),
        {
          recipienttype,
          title,
          message,
          type:"ceecampaign",
          ceecampaignid:ceecampaign.id,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Notification envoyée");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();


  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSelect
              inputTitle={ceenotificationtext.recipienttype}
              selectValue={recipienttype}
              handleSelectValueChange={handleRecipienttypeChange}
              data={ceenotificationsRecipienttypeData}
            />
          </div>
          <div>
            <TextInput
              inputTitle={ceenotificationtext.title}
              textInput={title}
              handleTextInputChange={handleTitleChange}
            />
          </div>
          <div>
            <TextInput
              inputTitle={ceenotificationtext.message}
              textInput={message}
              handleTextInputChange={handleMessageChange}
              multiline
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                sendNotification();
              }}
            >
              Envoyer
            </Button> 
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}
